<template>
  <div class="focus-list">
    <div class="title_wallet">我的钱包</div>
    <div class="information focus-item">
      <div class="header_box">
        <div class="leftbox">
          <div class="box-icon">
            <img src="../../assets/img/child/mine_xiaofei_jinkela.png" />
          </div>
          <div class="box-text">
            <div class="title">消费钱包</div>
            <div class="content">
              <span class="label">余额</span>
              <!-- <span class="value">{{ userInfo.diamond / 100 }}</span> -->
            </div>
          </div>
          <div class="box-button" @click="recharge">
            <div class>充值</div>
          </div>
        </div>

        <!-- <div class="rightbox">
          <div class="box-icon">
            <img src="../../assets/img/child/mine_top_qianbao.png" />
          </div>
          <div class="box-text">
            <div class="title">收入钱包</div>
            <div class="content">
              <span class="label">可提现佣金</span>
              <span class="value">{{ userAsset.profit_diamond }}</span>
            </div>
            <div class="content">
              <span class="label">累计到账</span>
              <span class="value">{{ userAsset.total_withdraw }}</span>
            </div>
          </div>
          <div class="box-button" @click="paypassowrd">
            <div class>提现</div>
          </div>
        </div> -->
      </div>
    </div>
    <!--    <RechargeDialog ref="RechargeDialog"></RechargeDialog>-->
    <WithdrawalDialog ref="WithdrawalDialog"></WithdrawalDialog>
    <PayPasswordDialog @confirm="withdrawal" ref="PayPasswordDialog"></PayPasswordDialog>
    <!-- 充值弹窗 -->
    <el-dialog title="金坷垃充值" :visible.sync="rechargeDialogVisible" width="663px">
      <el-form ref="form" :model="form" label-width="84px">
        <div class="purchase_list">
          <div class="purchase_text">购买数量：</div>
          <ul>
            <li v-for="item in purchaseQuantity" @click="Cmoney(item)" :key="item.id">
              <div class="top">
                <span class="number">{{ item.number }}</span>
                <span class="text">金坷垃</span>
              </div>
              <div class="bottom">¥{{ item.number }}</div>
            </li>
          </ul>
        </div>
        <el-form-item label="其他金额：" style="margin-top: 10px">
          <el-input v-model="form.name" placeholder="请输入1-99999的整数" style="width: 201px"></el-input>
        </el-form-item>
        <div class="pay_methods common_font_color">支付方式：</div>
        <div class="pay_methods_content">
          <div class="left">
            <ul>
              <li v-for="item in payMethodList" :key="item.id" @click="changeMethods(item.id)" :class="[item.id === payMethodId ? 'active' : '']">
                <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg" alt />
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <div class="right">
            <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg" alt />
            <span>支付宝扫一扫支付</span>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer_one" @click="CfirmChanges">
        <div>确认支付</div>
      </div>
    </el-dialog>

    <!-- 头像弹窗 -->
    <el-dialog title="选择头像" :visible.sync="avatorDialogVisible" width="533px" style="height: 432px">
      <ul class="avator_list">
        <li v-for="i in 18" :key="i">
          <img src="https://test-1301875615.cos.ap-beijing.myqcloud.com/images/20211013094041773982020-12-15%2021.33.14.jpg" alt />
        </li>
      </ul>
      <div slot="footer" class="dialog-footer_two">
        <div class="cancle" @click="avatorDialogVisible = false">取消</div>
        <div class="confirm">确认修改</div>
      </div>
    </el-dialog>
    <!-- 修改昵称 -->
    <el-dialog title="昵称修改" :visible.sync="nameChange" width="503px">
      <el-form ref="namebox" :model="namebox">
        <div class="special_text">验证将发送到您的手机：187****8765</div>
        <div>
          <div class="name_title">你的改名卡：32张</div>
          <div class="name_title_text">每次修改昵称消耗1张改名卡，并经审核后才能成功</div>
        </div>
        <div class="Current_name">
          <div>当前昵称：猎鹰直播9999999999</div>
        </div>
        <el-form-item>
          <el-input v-model="form.name" style="width: 320px" placeholder="请输入您的新昵称"></el-input>
        </el-form-item>
        <div class="code_last">
          <el-input placeholder="请输入验证码" v-model="form.input4" style="width: 201px">
            <i slot="prefix" style="width: 25px; display: flex; justify-content: center" class="font_family icon-a-icon_Verificationcode"></i>
          </el-input>
          <div class="send_text">获取验证码</div>
        </div>
        <el-form-item>
          <div class="dialog-footer_two">
            <div class="confirm submitinfo">确认修改</div>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import RechargeDialog from "@/components/dialog/RechargeDialog";
import WithdrawalDialog from "@/components/dialog/WithdrawalDialog";
import PayPasswordDialog from "@/components/dialog/PayPasswordDialog";
import { post } from "../../util/http";
import { mapMutations, mapState } from "vuex";
export default {
  components: {
    RechargeDialog,
    WithdrawalDialog,
    PayPasswordDialog,
  },
  data() {
    return {
      rechargeDialogVisible: false,
      nameChange: false,
      purchaseQuantity: [
        { id: 1, money: "1金坷垃", number: 1 },
        { id: 2, money: "9金坷垃", number: 9 },
        { id: 3, money: "48金坷垃", number: 48 },
        { id: 4, money: "98金坷垃", number: 98 },
        { id: 5, money: "498金坷垃", number: 498 },
        { id: 6, money: "998金坷垃", number: 998 },
        { id: 7, money: "4988金坷垃", number: 4988 },
        { id: 8, money: "9998金坷垃", number: 9998 },
      ],
      form: { name: "" },
      namebox: {},
      payMethodList: [
        { name: "支付宝1", id: 1 },
        { name: "支付宝2", id: 2 },
        { name: "支付宝3", id: 3 },
        { name: "支付宝4", id: 4 },
        { name: "支付宝5", id: 5 },
      ],
      payMethodId: 1,
      avatorDialogVisible: false,
    };
  },
  computed: {
    ...mapState(["userInfo", "userAsset"]),
  },
  methods: {
    recharge() {
      this.$router.push("/user-center/recharge");
    },
    withdrawal() {
      this.$refs.WithdrawalDialog.open();
    },
    paypassowrd() {
      this.$refs.PayPasswordDialog.open();
    },
    Cmoney(i) {
      let { number } = i;
      this.form.name = number;
    },
    // 修改昵称
    editclick() {
      this.nameChange = !this.nameChange;
    },
    // 提交充值金额
    async CfirmChanges() {
      try {
        const {
          data: { data },
        } = await post({
          url: "/api/order/send",
          data: { amount: 0, currency: this.form.name, payment_account_id: 0 },
        });
        //console.log(data, "data");
        this.list = data.list;
        this.totalCount = data.count;
      } catch (e) {}
    },
    changeMethods(id) {
      this.payMethodId = id;
    },
    editAvator() {
      this.avatorDialogVisible = true;
    },
  },
};
</script>
<style></style>

<style scoped lang="stylus">
	/deep/ {
		// @import "../../assets/modal_common.css";
	}

@import '../../assets/variable.styl';

.avator_list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  li {
    width: 60px;
    margin-bottom: 15px;

    img {
      width: 60px;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}

.text_qx, .special_text {
  height: 42px;
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #1c8c7a;
  justify-content: center;
}

.name_title {
  width: 115px;
  height: 30px;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  font-family: PingFangSC;
}

.name_title_text {
  font-family: PingFangSC;
  height: 30px;
  font-size: 12px;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Current_name {
  width: 100%;
  height: 40px;
  font-family: PingFangSC;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
}

.code_last {
  display: flex;
  justify-content: space-between;
  width: 318px;

  .send_text {
    height: 40px;
    width: 101px;
    height: 40px;
    border-radius: 3px;
    border: solid 1px #1c8c7a;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #1c8c7a;
    box-sizing: border-box;
    cursor: pointer;
  }
}

.submitinfo {
  width: 300px !important;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0.58), rgba(255, 255, 255, 0.58)), linear-gradient(to right, #58c0ab, #146c7e);
  color: #fff;
  font-family: PingFangSC;
  font-stretch: normal;
  font-style: normal;
}

.pay_methods_content {
  width: 542px;
  // height: 269px;
  border: solid 1px #d5d5d5;
  background-color: #fff;
  display: flex;
  box-sizing: border-box;
  margin-top: 19px;
  margin-bottom: 20px;

  .left {
    width: 120px;

    ul {
      li {
        box-sizing: border-box;
        list-style: none;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
        font-size: 14px;
        border-right: 1px solid #d5d5d5;

        img {
          width: 25px;
          height: 24px;
          margin-right: 7px;
        }

        span {
          color: #999;
          font-size: 14px;
        }
      }

      .active {
        border-right: none;
        border-left: 3px solid #1c8c7a;
        border-bottom: 1px solid #d5d5d5;
        border-top: 1px solid #d5d5d5;
        color: #333;
      }

      li:first-child {
        border-top: none;
      }

      li:last-child {
        border-bottom: none;
      }
    }
  }

  .right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    img {
      width: 152px;
      height: 153px;
    }

    span {
      color: #999;
      font-size: 14px;
    }
  }
}

.purchase_list {
  .purchase_text {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      display: flex;
      cursor: pointer;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border: solid 1px #d5d5d5;
      background-color: #fff;
      border-radius: 3px;
      width: 124px;
      height: 66px;
      margin-bottom: 14px;

      .top {
        color: #d9bc88;
        margin-bottom: 6px;
        font-weight: 600;
        display: flex;
        align-items: center;

        .number {
          font-size: 22px;
          margin-right: 3px;
        }

        .text {
          font-size: 14px;
        }
      }

      .bottom {
        font-size: 14px;
        color: #999;
      }
    }

    li:hover {
      box-shadow: 0 0 0 2px #b7d7d2, inset 0 0 0 1px #1c8c7a;
    }
  }
}

.focus-list {
  background: #ffffff;
  position: relative;

  .title_wallet {
    font-size: 18px;
    color: #333333;
    font-weight: 700;
    margin-left: 36px;
    margin-top: 30px;
    position: relative;
    width: 72px;
    text-align: center;
    z-index: 2;
  }



  // min-height: 100%;
  .focus-item {
    background-color: #ffffff;
    padding: 30px;

    // box-shadow: 2.1px 2.1px 10px 0 rgba(1, 26, 13, 0.1);
    .header_box {
      height: 100%;
      // display: flex;

      &>div {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        padding: 30px;
        border-radius: 8px;
        margin: 0px 5px;

        .box-icon {
          padding-right: 30px;

          img {
            width: 52px;
            height: 52px;
          }
        }

        .box-text {
          .title {
            line-height: 25px;
            font-size: 18px;
            color: #333333;
            letter-spacing: 0;
            font-weight: 600;
            padding-bottom: 8px;
          }

          .content {
            display: flex;
            align-items: center;

            .label {
              font-size: 14px;
              color: #666666;
              letter-spacing: 0;
              font-weight: 400;
              padding-right: 5px;
            }

            .value {
              font-size: 18px;
              color: #333333;
              letter-spacing: 0;
              font-weight: 500;
            }
          }
        }

        .box-button {
          cursor: pointer;
          flex: 1;
          display: flex;
          justify-content: flex-end;

          &>div {
            font-size: 16px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            font-weight: 500;
            border-radius: 18px;
            padding: 8px 20px;
          }
        }
      }

      .leftbox {
        height:100px;
        width:380px;
        background: linear-gradient(90deg, #ECFFEC 0%, #DFFFFD 100%);
        border-radius: 5px;
        margin-right :15px;

        .box-button {
          &>div {
            background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
          }
        }
      }

      .rightbox {
        height:100px;
        width:380px;
        background: linear-gradient(90deg, #FFF3C9 0%, #FFEDE6 100%);
        border-radius: 5px;

        .title {
          padding-bottom: 4px;
        }

        .content {
          padding-bottom: 5px;
        }

        .box-button {
          &>div {
            background: linear-gradient(136.27deg, #FFD600 20%, #FF8F00 95.56%);
          }
        }
      }
    }
  }

  .information {
    height: 170px;
    box-sizing: border-box;
    margin-top: 0px;

    // display: flex;
    // justify-content: space-between;
    .top {
      display: flex;
      justify-content: space-between;
    }

    .avator {
      width: 122px;
      height: 122px;
      background-color: #dddddd;
      border-radius: 3px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      cursor: pointer;

      span {
        font-size: 12px;
        color: #fff;
        height: 20px;
        background-color: #676767;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .right_content {
      flex: 1;
      height: 122px;
      margin-left: 23px;

      .first_line {
        display: flex;
        // align-items: center;
        justify-content: space-between;
        align-items: center;

        .left {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #333;
          cursor: pointer;
        }

        .right {
        }
      }

      .second_line {
        display: flex;
        margin-top: 26px;

        .left {
          font-size: 14px;
          color: #333;
          display: flex;
          align-items: center;

          .account {
            display: flex;
            align-items: center;
          }

          .live_name {
            display: flex;
            align-items: center;
            margin-left: 42px;
          }

          .money_icon {
            width: 15px;
            height: 15px;
            object-fit: contain;
            margin-right: 5px;
          }
        }
      }

      .third_line {
        display: flex;
        margin-top: 16px;

        .left {
          display: flex;
          align-items: center;

          .level_item {
            width: 45px;
            height: 17px;
            text-align: center;
            line-height: 17px;
            color: #fff;
            border-radius: 20px;
            font-size: 12px;
          }

          .level_item_last {
            background-color: #ff9633;
          }

          .level_item_next {
            background-color: #cccccc;
          }

          .level_progress {
            padding: 0 8px;
            width: 161px;
            height: 4px;

            .level_progress_default {
              width: 161px;
              height: 4px;
              background: #cccccc;
              position: relative;
              border-radius: 10px;
              overflow: hidden;
            }

            .level_progress_active {
              position: absolute;
              left: 0;
              top: 0;
              width: 50%;
              height: 4px;
              background-color: #ff9633;
            }
          }
        }

        .right {
          margin-left: 30px;

          .topup_button {
            width: 60px;
            height: 30px;
            background-color: #fff;
            border-radius: 2px;
            border: solid 1px #d9bc88;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #d9bc88;
            cursor: pointer;
          }
        }
      }
    }

    .tips {
      display: flex;
      align-items: center;
      color: #d9bc88;
      font-size: 12px;

      .tips_icon {
        width: 15px;
        height: 15px;
        object-fit: contain;
        margin-right: 5px;
      }
    }
  }

  .information_bottom {
    margin-top: 0px;
  }
}
</style>
